<template>
  <div class="home">
    <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <div class="img">
      <img :src="$store.getters.systemLogoHome" />
    </div>

    <div v-for="item in modules" :key="item.moduleId" class="module">
      <home-image-hover class="image" alt="Image" :image="item.inputImage">
      </home-image-hover>
      <div v-if="item.active">
        <a v-if="isExternalUrl(item)" class="link" :href="getUrl(item)">
          <b-button class="b2 button-with-badge">
            {{ item.moduleName }}
            <span class="badge">Novo</span>
          </b-button>
        </a>
        <router-link v-else class="link" :to="getUrl(item)">
          <b-button class="b2">
            {{ item.moduleName }}
          </b-button>
        </router-link>
      </div>
      <b-button v-else class="b2 disabled-module">
        {{ item.moduleName }}
      </b-button>
      <div class="back"></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    HomeImageHover: () => import("./HomeImageHover.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      msgErro: "",
      modules: {},
    };
  },
  created() {
    this.getModules();
    this.validateUser();
  },
  computed: {},
  methods: {
    getUrl(item) {
      if (item.moduleType == 2) {
        return `/bi/`;
      }
      if (item.moduleType == 3) {
        if (this.$store.getters.isChecklistFormCreator) {
          return `/checklist/dashboard/default/`;
        } else if (this.$store.getters.isChecklistFormFiller) {
          return `/checklist/Layout/form/own/`;
        } else if (this.$store.state.checklist) {
          return `/checklist/Layout/form/Filled/`;
        }
      }
      if (item.moduleType == 4) {
        if (this.$store.getters.isCompanyShipper) {
          return `/dashboard/`;
        } else if (this.$store.getters.isCargoKanbamAvaliable) {
          return `/trackingShippingCompany/cargo/kanban/`;
        } else if (this.$store.getters.isCargoExpensesAvaliable) {
          return `/trackingShippingCompany/cargoExpense/kanban`;
        } else if (this.$store.getters.hasAccessLoads) {
          return `/trackingShippingCompany/cargo/list`;
        }
      }
      if (item.moduleType == 5) {
        return `/workflow/processList`;
      }
      if (item.moduleType == 6) {
        return `/financial/dashboard`;
      }
      if (item.moduleType == 7) {
        return `https://simuladordefretes.com/`;
      }
      return `/modulo/${item.moduleId}/`;
    },
    isExternalUrl(item) {
      let url = this.getUrl(item);
      if (url.startsWith("http")) {
        return true;
      }
      return false;
    },
    validateUser() {
      this.$apiScheduler
        .get("/validateUser/")
        .then((response) => {
          let user = response.data;
          // console.log("user");
          // console.log(user);
          if (user.forceChangePassword) {
            this.$router.push(`/user/passwordReset/${user.id}`);
          }
          // console.log(this.modules);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$router.push({ path: "home" });

            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else if (error.response.status == 404) {
            this.$router.push("/login");
          }
          console.log(error);
          console.log(error);
          console.log(error.response.data);
          this.alert.error = error.response.data.errors;
          this.$refs.fadeAlertDanger.show();
          return null;
        });
    },
    getModules() {
      this.$apiScheduler
        .get("/getModules/")
        .then((response) => {
          // console.log(response);
          this.validateUser();
          this.setEncryptedPassword();
          this.modules = response.data;
          if (this.modules.length == 0) this.$router.push({ path: "home" });
          // console.log(this.modules);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$router.push({ path: "home" });
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error);
          console.log(error.response.data.errors);

          return null;
        });
    },
    setEncryptedPassword() {
      this.$apiScheduler
        .post("/user/SetEncryptedPassword/")
        .then((response) => {})
        .catch((error) => {
          if (error.response.status == 401) {
            this.$router.push({ path: "home" });
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error);
          console.log(error.response.data.errors);

          return null;
        });
    },
  },
};
</script>

<style scoped>
.home {
  text-align: center;
  overflow: visible; /* Garante que o selo não seja cortado */
}
@media (max-width: 768px) {
  .home .img {
    width: 100%;
  }
  .home .img img {
    width: 300px;
  }

  .badge {
    font-size: 0.6rem; /* Reduz o tamanho da fonte */
    padding: 2px 6px; /* Ajusta o padding */
    top: -5px;
    right: -10px;
  }

  .button-with-badge {
    width: 100%; /* Garante que o botão ocupe toda a largura */
  }
}

@media (min-width: 768px) {
  .home {
    display: flex;
    justify-content: space-evenly;
  }
  .home .img {
    margin-top: 200px;
    position: absolute;
    width: 600px;
    /* height: 300px; */
    z-index: -2;
  }
}
.b2,
.b3,
.b4,
.b5,
.b6,
.b7,
.b8 {
  width: 300px;
  height: 80px;
  max-width: 100%;
}
@media (min-width: 992px) {
  .home .img {
    margin-top: 150px;
    position: absolute;
    width: 500px;
    /* height: 300px; */
    z-index: -2;
  }

  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 140px;
    height: 120px;
    margin-top: 31rem;
    max-width: 100%;
  }
}
@media (min-width: 1200px) {
  .home .img {
    margin-top: 150px;
    position: absolute;
    width: 500px;
    /* height: 300px; */
    z-index: -2;
  }

  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 180px;
    height: 150px;
    margin-top: 31rem;
    max-width: 100%;
  }
}
@media (min-width: 1500px) {
  .home .img {
    margin-top: 200px;
    position: absolute;
    width: 600px;
    /* height: 300px; */
    z-index: -2;
  }

  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 180px;
    height: 150px;
    margin-top: 43rem;
    max-width: 100%;
  }
}
.disabled-module {
  background: gray !important;
  cursor: not-allowed !important;
}
.module:hover .image {
  opacity: 1;
}

.home .container {
  max-width: 100% !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.image {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  z-index: -2;
  transition: 0.5s ease;
}
.back {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
}
.home .footer {
  position: absolute;
  margin-top: 46%;
}

.button-with-badge {
  position: relative;
  overflow: visible; /* Garante que o selo não seja cortado */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.button-with-badge:hover {
  transform: translateY(-5px); /* Eleva o botão ao passar o mouse */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3); /* Adiciona sombra */
}

.module {
  overflow: visible; /* Garante que o selo não seja cortado */
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1) rotate(10deg);
  }
  50% {
    transform: scale(1.1) rotate(10deg);
  }
}

.badge {
  animation: pulse 2s infinite; /* Animação de pulsar */
  position: absolute;
  top: 15px; /* Ajuste para afastar mais do topo */
  right: 10px; /* Ajuste para afastar mais da borda direita */
  background-color: #00ff00; /* Verde mais vibrante */
  color: #00163f; /* Contraste com o fundo */
  font-size: 0.8rem; /* Tamanho da fonte ajustado */
  font-weight: bold;
  padding: 4px 10px; /* Ajuste para um formato mais fluido */
  border-radius: 12px; /* Torna o selo mais oval */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transform: rotate(10deg); /* Inclinação mais sutil */
  z-index: 10; /* Garante que o selo fique acima de outros elementos */
}
</style>